import React from 'react';
import components from './components';
import { MDXProvider as Provider } from '@mdx-js/react';

export function MDXProvider({ element }) {
    return <Provider components={components} children={element} />;
}
